import React from 'react';
import PropTypes from 'prop-types';
import { numberFormatter } from '../../../../utils/number';

const BankReconciliationCountAmountCell = ({
  count,
  amount,
  highlightClassName,
}) => (
  <span className={count || amount ? highlightClassName : ''}>
    {`${count || 0} - ${numberFormatter({ value: amount || 0 })}`}
  </span>
);

BankReconciliationCountAmountCell.propTypes = {
  count: PropTypes.number,
  amount: PropTypes.number,
  highlightClassName: PropTypes.string.isRequired,
};

BankReconciliationCountAmountCell.defaultProps = {
  count: 0,
  amount: 0,
};

export default BankReconciliationCountAmountCell;
